import { render, staticRenderFns } from "./address-field.vue?vue&type=template&id=f4545b68&"
import script from "./address-field.vue?vue&type=script&lang=js&"
export * from "./address-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports